module.exports = __webpack_public_path__ + "static/077866491-1910s-birth-telephone-operator_H264_420_1-7d0d441087beee23c1200a6d5ba29323.mp4";